export default "__VITE_ASSET__NjMN$lRB__"